<template>
	<div>
		<div class="box" ref="box">
			<div class="roll-box">
				<slot></slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "roll",
	props: {

	},
	data() {
		return {
			boxWidth: 0,
			rollBoxWidth: 0,
			x: 0
		}
	},
	mounted() {
		window.addEventListener("resize", this.viewResize.bind(this), false);
	},
	methods: {
		// 视口改变时触发
		viewResize() {
      if (this.$refs.box) {
        let rollBoxEl = this.$refs.box.querySelector(".roll-box")
        let boxWidth = this.$refs.box.offsetWidth
        let rollBoxWidth = rollBoxEl.scrollWidth
        if(this.boxWidth == (this.rollBoxWidth - Math.abs(this.x)) ) {
          this.boxWidth = boxWidth
          this.rollBoxWidth = rollBoxWidth
          this.x = -Math.abs(boxWidth - rollBoxWidth)
        }
        if(boxWidth >= rollBoxWidth) {
          this.x = 0
        }
        rollBoxEl.style.transform = `translateX(${this.x}px)`
      }
		},
		goNext() {
			// this.$refs.box.style.width = "300px"
			// return
			let rollBoxEl = this.$refs.box.querySelector(".roll-box")
			this.boxWidth = this.$refs.box.offsetWidth
			this.rollBoxWidth = rollBoxEl.scrollWidth
			if(this.boxWidth > this.rollBoxWidth) return
			this.x -= this.boxWidth
			if( Math.abs(this.x) > Math.abs(this.boxWidth - this.rollBoxWidth)) {
				this.x = -Math.abs(this.boxWidth - this.rollBoxWidth)
			}
			rollBoxEl.style.transform = `translateX(${this.x}px)`;
		},
		goPre() {
			let rollBoxEl = this.$refs.box.querySelector(".roll-box")
			this.boxWidth = this.$refs.box.offsetWidth
			this.rollBoxWidth = rollBoxEl.scrollWidth
			if(this.boxWidth > this.rollBoxWidth) return
			this.x += this.boxWidth
			if(this.x > 0) {
				this.x = 0
			}
			rollBoxEl.style.transform = `translateX(${this.x}px)`;
		},
	},
	destroyed() {
		window.removeEventListener('resize', this.viewResize)
	}
}
</script>

<style scoped lang="scss">
	.box {
		overflow: hidden;
		.roll-box {
			height: auto;
			width: 100%;
			transition: all .3s;
		}
	}

</style>
